module.exports = new __parcel__URL__("generic-empty-state.7d871e1a.svg").toString();